import { h as __h } from "preact";
/** @import { ComponentChildren } from "preact"; */

import html from "~/util/html.js";
import Icon from "./Icon.js";
import util from "~/style/util.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Section.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Section.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {ComponentChildren} title
 * @property {string | undefined} [icon]
 * @property {boolean | undefined} [flat]
 * @property {boolean | undefined} [fullBleed]
 * @property {boolean | undefined} [bare] Renders the children without a surrounding card, e.g. for
 *   several cards
 * @property {ComponentChildren | undefined} [subtitle]
 * @property {ComponentChildren | undefined} [description]
 * @property {ComponentChildren | undefined} [actions]
 * @property {ComponentChildren | undefined} [children]
 */

/** @param {Props} props */
export default function Section({
  icon,
  title,
  subtitle,
  description,
  actions,
  flat,
  fullBleed,
  bare,
  children
}) {
  return __h("section", {
    "class": css.wrapper
  }, __h("header", {
    "class": css.header
  }, __h("h2", {
    "class": css.title
  }, icon !== undefined && [" ", __h(Icon, {
    name: icon
  }), " "], __h("span", {}, title), subtitle), actions), description !== undefined && __h("p", {
    "class": css.description
  }, description), bare ? children : __h("div", {
    "class": (flat ? css.border : util.card) + " " + css.content,
    "data-fullbleed": fullBleed
  }, children));
}